import { __generator } from "tslib";
import { all, put, call, takeEvery } from 'redux-saga/effects';
import { request } from '../../xhr';
import { fetchArtAuthor, fetchArtAuthorSuccess } from './actions';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        var users = require('@wix/da-sample-data').users;
        var randomUser = users[Math.round(Math.random() * (users.length - 1))];
        return {
            user: randomUser,
        };
    }
}
function fetchAuthor(action) {
    var username, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                username = action.payload.username;
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: '/user/info',
                        params: { username: username },
                    }, fakeResponse)];
            case 1:
                response = _a.sent();
                if (!(response && response.user)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchArtAuthorSuccess({
                        user: response.user,
                    }))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeEvery(fetchArtAuthor, fetchAuthor)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map